<template>
  <div>
    <el-table
      v-loading="loading"
      :data="data"
      border
      stripe
      @row-click="handleRowClick">
      <el-table-column
        v-for="(header, index) in headers"
        :key="header.value || index"
        :fixed="index === 0"
        :formatter="header.formatter"
        :prop="header.value"
        :label="header.label"
        :width="header.width
          ? header.width
          : calculateWidthByContent(header.label)
        "
      >
      </el-table-column>
      <slot name="editTransactionStatus"></slot>
      <template slot="empty">
        <el-empty description="ไม่พบข้อมูล"></el-empty>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    calculateWidthByContent(text) {
      const length = text ? text.length : 0
      return `${length * 6 + 100}px`
    },
    handleRowClick(data) {
      this.$emit('rowClick', data)
    }
  }
}
</script>
<style>
.table-header {
  font-size: large;
  width: max-content;
}
.el-table__cell {
  color: rgb(34, 34, 34);
}
.el-table__header-wrapper {
  position: unset;
  padding-top: 0px !important;
}

.el-table__body-wrapper {
  padding-top: 0px !important;
}

@media screen and (max-width: 1680px) {
  .el-table__body-wrapper {
    position: unset;
    padding-top: 0px !important;
  }
}
</style>